import { createAction, ActionCancelledError } from "@coverme/redux";
import Axios from "axios";

export const getAssistanceCategoriesForProgram = (customerId) =>
    createAction("GET_ASSISTANCE_CATEGORIES", () =>
        Axios.get(`/api/program/customer/${customerId}/subscriptions/assistanceCategories`).then(res => res.data)
    );
